import React, {useState} from "react";
import '../../scss/components/ProfileTabs.scss';
import TabPersonalData from './SingleTabs/TabPersonalData.tsx';
import TabContactBusiness from "./SingleTabs/TabContactBusiness.tsx";
import TabBankConnection from "./SingleTabs/TabBankConnection.tsx";
import TabPrivateData from "./SingleTabs/TabPrivateData.tsx";
import TabOfficialData from "./SingleTabs/TabOfficialData.tsx";
import TabPermits from "./SingleTabs/TabPermits.tsx";
import TabServices from "./SingleTabs/TabServices.tsx";
import TabLanguages from "./SingleTabs/TabLanguages.tsx";
import TabCoachingForms from "./SingleTabs/TabCoachingForms.tsx";
import TabRemunerationModel from "./SingleTabs/TabRemunerationModel.tsx";
import { NavLink, Navigate } from "react-router-dom";
import TabCommon from "./SingleTabs/TabCommon.tsx";
import PageTitle from '../../features/functions/title.tsx';
import TabCertificates from "./SingleTabs/TabCertificates.tsx";
import { useProfileContext } from "../../features/auth/hooks/use-profile-context.ts";

type TabDefinition = {
    label: string,
    content: React.ReactNode,
    requiresValidation?: boolean,
};

const ProfileTabs = ({
    profile,
    setProfile,
    active,
    addition
}) => {
    const { needsInitialReview } = useProfileContext();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const tabConfig: Record<string, TabDefinition> = {
        common: {
            label: 'Allgemeines',
            content: <><PageTitle title={'Allgemeines'} /><TabCommon profile={profile} setProfile={setProfile} /></>
        },
        personaldata: {
            label: 'Persönliche Angaben',
            content: <><PageTitle title={'Persönliche Angaben'} /><TabPersonalData profile={profile} setProfile={setProfile} /></>
        },
        privatedata: {
            label: 'Private Kontaktdaten',
            content: <><PageTitle title={'Private Kontaktdaten'} /><TabPrivateData profile={profile} setProfile={setProfile} /></>
        },
        officialdata: {
            label: 'Geschäftliche Kontaktdaten',
            content: <><PageTitle title={'Geschäftliche Kontaktdaten'} /><TabOfficialData profile={profile} setProfile={setProfile} /></>
        },
        contactbusiness: {
            label: 'Bevorzugte Kontaktierung',
            content: <><PageTitle title={'Bevorzugte Kontaktierung'} /><TabContactBusiness profile={profile} setProfile={setProfile} /></>
        },
        bankconnection: {
            label: 'Rechnungsdaten / Zahlungsmethode',
            // Hidden for ZP candidates until the area is adapted for them (post go-live);
            // the registration form creates its billing accounts inline.
            requiresValidation: true,
            content: <><PageTitle title={'Rechnungsdaten / Zahlungsmethode'} /><TabBankConnection profile={profile} addition={addition}/></>
        },
        certifications: {
            label: 'Zertifikate',
            requiresValidation: true,
            content: <><PageTitle title={'Zertifikate'} /><TabCertificates /></>
        },
        languages: {
            label: 'Beratungssprachen',
            requiresValidation: true,
            content: <><PageTitle title={'Beratungssprachen'} /><TabLanguages profile={profile} setProfile={setProfile} /></>
        },
        services: {
            label: 'Beratungs- und Dienstleistungsangebote',
            requiresValidation: true,
            content: <><PageTitle title={'Beratungs- und Dienstleistungsangebote'} /><TabServices profile={profile} setProfile={setProfile} /></>
        },
        coachingforms: {
            label: 'Beratungsformen',
            requiresValidation: true,
            content: <><PageTitle title={'Beratungsformen'} /><TabCoachingForms profile={profile} setProfile={setProfile} /></>
        },
        permits: {
            label: 'Gesetzliche Zulassungen und Erlaubnisse',
            requiresValidation: true,
            content: <><PageTitle title={'Gesetzliche Zulassungen und Erlaubnisse'} /><TabPermits profile={profile} setProfile={setProfile} /></>
        },
        remunerationmodel: {
            label: 'Vergütungsmodell',
            requiresValidation: true,
            content: <><PageTitle title={'Vergütungsmodell'} /><TabRemunerationModel profile={profile} setProfile={setProfile} /></>
        },
    };
    const visibleTabKeys = Object.keys(tabConfig).filter(
        (key) => !(needsInitialReview && tabConfig[key].requiresValidation)
    );

    const activeTab = active ? active : visibleTabKeys[0];

    if (!visibleTabKeys.includes(activeTab)) {
        return <Navigate to={`/profile/${visibleTabKeys[0]}`} replace />
    }

    return (
        <div className="tabs">
            <div className={`tab-nav${isOpen ? ' open' : ''}`} onClick={() => {if (!isOpen) { setIsOpen(true) }}}>
                { visibleTabKeys.map((key) => (
                    <NavLink onClick={() => {setIsOpen(false)}} key={key} className={`tab-nav-item${activeTab === key ? ' active' : ''}`} to={`/profile/${key}`} end>{ tabConfig[key].label }</NavLink>
                )) }
                <div className={`hamburger${isOpen ? ' is-active' : ''}`} onClick={() => setIsOpen(!isOpen)}><div className="hamburger-box"><div className="hamburger-inner"></div></div></div>
            </div>
            <div className={`current-tab ${activeTab}`}>
                <h2 className="h4">{ tabConfig[activeTab].label }</h2>
                { tabConfig[activeTab].content }
            </div>
        </div>
    )
}

export default ProfileTabs;